export const fieldsToBeModify = ['dateOfBirth', 'govId', 'passport', 'gender']
export const REQUIRED = 'required'
export const PURCHASER_OPTIONS = { myself: 'myself', other: 'other' }

export const clearRequiredRules = (schemaElements) => {
  Object.entries(schemaElements).forEach(([key, value]) => {
    if (fieldsToBeModify.includes(key)) {
      const hasOtherRules = value.rules?.split('|').filter((element) => {
        return element !== REQUIRED
      })

      value.rules = hasOtherRules ? hasOtherRules.join('|') : ''
    }
  })
}

const productsFields = {
  1: [
    {
      requiredFields: ['dateOfBirth'],
      buyForMyself: true,
    },
  ],
  2: [
    {
      requiredFields: ['dateOfBirth', 'govId', 'passport', 'gender'],
      buyForMyself: true,
    },
  ],
  3: [
    {
      requiredFields: ['dateOfBirth', 'govId', 'passport', 'gender'],
      buyForMyself: 'any',
    },
  ],
  4: [ // this is for RO
    {
      requiredFields: ['dateOfBirth', 'govId', 'passport', 'gender'],
      buyForMyself: 'any',
    },
  ],
}

const unRequiredFields = ['phone', 'email']

export const setRequiredRules = (level, schemaElements, purchaser, cartItems) => {
  const requiredFields = productsFields[level]?.reduce((fields, terms) => {
    if (terms.buyForMyself === (purchaser === PURCHASER_OPTIONS.myself) || terms.buyForMyself === 'any') {
      fields = terms.requiredFields
    }
    return fields
  }, []) || []

  if (purchaser === PURCHASER_OPTIONS.other) {
    if (cartItems.find(({ _typename }) => _typename === 'MedicalCheckCartItem')) {
      // MED-2711
      requiredFields.push('dateOfBirth')
    }
  }

  if (purchaser === PURCHASER_OPTIONS.myself) {
    if (cartItems.find(({ vendor }) => vendor.name === 'Diagnostyka')) {
      requiredFields.push('phone')
    }
  }

  requiredFields.forEach((field) => {
    schemaElements[field].rules = [...new Set([...(schemaElements[field].rules || '').split('|'), REQUIRED])].join('|')
  })
}

export const setUnrequiredRules = (schemaElements) => {
  unRequiredFields.forEach((field) => {
    schemaElements[field].rules = schemaElements[field].rules.split('|').filter(e => e !== 'required').join('|')
  })
}

export const setUnrequiredRulesForDiagnostyka = (unrequiredFields, schemaElements) => {
  unrequiredFields.forEach((field) => {
    schemaElements[field].rules = schemaElements[field].rules.split('|').filter(e => e !== 'required').join('|')
  })
}
